import CornerRibbon from 'react-corner-ribbon';

export const EnvironmentRibbon = () => {
  return (
    <CornerRibbon position="top-left">{process.env.REACT_APP_ENV}</CornerRibbon>
  );
};
